import { render } from "./CompetentionView.vue?vue&type=template&id=09e53901"
import script from "./CompetentionView.vue?vue&type=script&lang=js"
export * from "./CompetentionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__